import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react";
import { login } from "../services/authService";


const API = process.env.REACT_APP_API_URL;


const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState(() => {
	  const storedUser = localStorage.getItem("user");
	  return storedUser ? JSON.parse(storedUser) : null;
	});
  const [token, setToken] = useState(localStorage.getItem("token") || "");

  useEffect(() => {
    if (token) {
      
    }
  }, [token]);

  const handleLogin = async (username: string, password: string) => {
	  try {
		const res = await login(username, password);
		//console.log("Login response:", res);

		if (!res.access_token) throw new Error("Token tidak ditemukan di response");

		//setToken(res.token);
		const token = res.access_token;
		localStorage.setItem("token", res.access_token);
		
		localStorage.setItem(
		  "user",
		  JSON.stringify({
			...res.user,
			tenantId: res.user.tenant_id,
			createdByUserId: res.user.id,
		  })
		);


		setToken(token);
		setUser(res.user);

		
		//const profile = await getProfile(username);
		//console.log("Profile response:", profile);

		//setUser(res.user);
	  } catch (error) {
		console.error("Login error:", error);
		throw error; // biar ditangani di LoginPage
	  }
	};


  const logout = () => {
    setUser(null);
    setToken("");
    localStorage.removeItem("token");
	localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, token, login: handleLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
